// extracted by mini-css-extract-plugin
export default {"multiSelect":"MultiSelect_multiSelect__OZKE-","heading":"MultiSelect_heading__ncM7d"};